/* eslint-disable */

/*
 * ⚠️ DO NOT EDIT ⚠️
 * This file is automatically generated, run "yarn run codegen"
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type GetPostsQueryVariables = Exact<{
  club_id: number;
}>;

export type GetPostsQuery = {
  __typename: 'query_root';
  socials_post:
    | Array<{
        __typename: 'socials_post';
        post_id: string | undefined;
        post_text: string | undefined;
        creation_index: number | undefined;
        feed_id: string | undefined;
        image_height: number | undefined;
        image_url: string | undefined;
        image_width: number | undefined;
        post_additional: unknown;
        post_permalink: string | undefined;
        post_status: string | undefined;
        post_timestamp: number | undefined;
        post_type: string | undefined;
        user_counts_followed_by: number | undefined;
        user_counts_follows: number | undefined;
        user_counts_media: number | undefined;
        user_link: string | undefined;
        user_nickname: string | undefined;
        user_pic: string | undefined;
        user_screenname: string | undefined;
      }>
    | undefined;
};

export const GetPostsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetPosts' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'club_id' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'socials_post' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'facebook' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'club_id' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: '_eq' },
                                  value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'club_id' },
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'post_timestamp' },
                      value: { kind: 'EnumValue', value: 'desc' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'IntValue', value: '3' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'post_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'post_text' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'creation_index' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'feed_id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'image_height' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'image_url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'image_width' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'post_additional' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'post_permalink' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'post_status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'post_timestamp' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'post_type' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user_counts_followed_by' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user_counts_follows' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user_counts_media' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'user_link' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user_nickname' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'user_pic' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user_screenname' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPostsQuery, GetPostsQueryVariables>;
